import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=b1912b42&scoped=true"
import script from "./SearchField.vue?vue&type=script&lang=ts"
export * from "./SearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1912b42",
  null
  
)

export default component.exports